<template>
  <div v-if="participants">
    <beautiful-chat :participants="participants" :titleImageUrl="titleImageUrl" :onMessageWasSent="onMessageWasSent" :messageList="messageList" :newMessagesCount="newMessagesCount" :isOpen="true" :close="closeChat" :open="openChat" :showEmoji="false" :showFile="false" :showTypingIndicator="showTypingIndicator" :colors="colors" :alwaysScrollToBottom="true" :messageStyling="messageStyling" @onType="handleOnType" />
  </div>
</template>

<script>
import moment from "moment";
import socket from "@/services/socket";

export default {
  name: "message",

  mounted() {
    let that = this;
    if (this.messageThread) {
      this.participants = [
        {
          id: this.messageThread.to.id,
          name:
            this.messageThread.from.firstName +
            " " +
            this.messageThread.from.lastName,
        },
      ];

      this.messageList = this.messageThread.conversation.map((msg) => {
        return {
          type: "text",
          author: this.user._id == msg.userId ? "me" : msg.userId,
          data: {
            text: msg.content || "",
          },
        };
      });
    }

    socket.on("newMessage", async (data) => {
      if (data.toUser == that.user._id) {
        await that.$store.dispatch("getMessages", that.user._id);

        if (
          this.$store.state.messages &&
          this.$store.state.messages.length > 0
        ) {
          let message = this.$store.state.messages.find((msg) => {
            return msg._id == this.messageThread._id;
          });

          if (message) {
            this.messageThread = message;
          }
        }
      }
    });
  },

  beforeDestroy() {
    socket.off("newMessage");
  },

  data() {
    return {
      participants: null,
      titleImageUrl:
        "https://a.slack-edge.com/66f9/img/avatars-teams/ava_0001-34.png",
      messageList: null,
      newMessagesCount: 0,
      showTypingIndicator: "", // when set to a value matching the participant.id it shows the typing indicator for the specific user
      colors: {
        header: {
          bg: "var(--color-primary)",
          text: "#ffffff",
        },
        launcher: {
          bg: "#4e8cff",
        },
        messageList: {
          bg: "#ffffff",
        },
        sentMessage: {
          bg: "var(--color-primary)",
          text: "#ffffff",
        },
        receivedMessage: {
          bg: "#eaeaea",
          text: "#222222",
        },
        userInput: {
          bg: "#f4f7f9",
          text: "#565867",
        },
      }, // specifies the color scheme for the component
      messageStyling: true, // enables *bold* /emph/ _underline_ and such (more info at github.com/mattezza/msgdown)
    };
  },

  computed: {
    user() {
      return JSON.parse(localStorage.user);
    },
    messageThread: {
      get() {
        return this.$store.state.message;
      },
      set(value) {
        this.$store.state.message = value;
        this.messageList = value.conversation.map((msg) => {
          return {
            type: "text",
            author: this.user._id == msg.userId ? "me" : msg.userId,
            data: {
              text: msg.content,
            },
          };
        });
      },
    },
  },

  methods: {
    async onMessageWasSent(message) {
      this.messageThread.conversation.push({
        userId: this.user._id,
        content: message.data.text,
        time: moment.utc().format(),
      });

      try {
        this.messageThread = await this.$store.dispatch(
          "sendMessage",
          this.messageThread
        );
        socket.emit("newMessage", {
          fromUser: this.user._id,
          toUser: this.messageThread.to.id,
          messageId: this.messageThread._id,
        });
      } catch (e) {
        console.log(e);
      }
    },
    openChat() {
      // called when the user clicks on the fab button to open the chat
      this.isChatOpen = true;
      this.newMessagesCount = 0;
    },
    closeChat() {
      // called when the user clicks on the botton to close the chat
      this.isChatOpen = false;
    },
    handleScrollToTop() {
      // called when the user scrolls message list to top
      // leverage pagination for loading another page of messages
    },
    handleOnType() {},
  },
};
</script>

<style scoped>
/deep/ .sc-chat-window {
  position: relative;
  height: 93vh;
}
/deep/ .sc-header--close-button {
  display: none;
}
/deep/ .sc-message-list {
  height: 90%;
}
/deep/ .sc-user-input--buttons {
  inset-inline-end: 0px;
}
</style>
